import { defineComponent as _defineComponent } from 'vue'
import { ref, PropType } from "vue"
import AppPage from "@/components/layout/AppPage.vue"
import {
  SubmitApplicationMutation,
  ApplicationTrack,
  SubmitApplicationMutationMutation,
  SubmitApplicationMutationMutationVariables,
} from "@/gql"
import { useMutation } from "@/hooks/useMutation"
import { useNotification } from "@/hooks/useNotification"
import { APPLICANT_ID_KEY } from "@/components/apply/shared/constants"
import Completed from "@/components/apply/shared/Completed.vue"


export default /*#__PURE__*/_defineComponent({
  __name: 'Review',
  props: {
  applicationTrack: {
    type: Object as PropType<ApplicationTrack | null>,
    required: true,
  },
},
  setup(__props) {

const props = __props

const { mutate } = useMutation()
const { addSuccess } = useNotification()
const isSubmitting = ref(false)

const showSubmitDialog = ref(false)
const applicantId = localStorage.getItem(APPLICANT_ID_KEY) || ""



const submitSuccessful = ref(false)

const submitApplication = async () => {
  if (!props.applicationTrack?.prn) return
  isSubmitting.value = true

  // Mutate
  const result = await mutate<
    SubmitApplicationMutationMutation,
    SubmitApplicationMutationMutationVariables
  >({
    mutation: SubmitApplicationMutation,
    variables: {
      applicantId,
      applicationTrackId: props.applicationTrack?.prn,
    },
    handlePayloadErrors: true,
  })

  // Done
  if (result?.data && !result.data.submitApplication.error) {
    addSuccess("Application submitted")
    submitSuccessful.value = true
  }

  isSubmitting.value = false
}

return { __sfc: true,mutate, addSuccess, isSubmitting, showSubmitDialog, applicantId, props, submitSuccessful, submitApplication, AppPage, Completed }
}

})